import React from "react";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import styled from "styled-components";
import { RichTextHTML } from "../../RichTextHTML";
import { RichTextPortableText } from "../../RichTextPortableText";
const StylableRichText = ({ type, body, allowedTags, className, ...htmlProps }) => {
    return (React.createElement("div", { className: `richText ${className}`, ...htmlProps },
        type === "html" && React.createElement(RichTextHTML, { rawHTML: preProcess(body || ""), allowedTags: allowedTags }),
        type === "portableText" && React.createElement(RichTextPortableText, { rawPortableText: body, supportedTags: allowedTags })));
};
StylableRichText.defaultProps = {
    "data-testid": "rich-text",
};
const preProcess = (raw) => {
    let processed = raw;
    processed = processed.replace(/( margin: 0px;|margin: 0px;)/g, "");
    processed = processed.replace(/float: left;">/g, 'float: left;" class="left">');
    processed = processed.replace(/float: right;">/g, 'float: right;" class="right">');
    processed = processed.replace(/column-count: 2">/g, 'column-count: 2" class="two-column-layout">');
    processed = processed.replace(/<table/g, '<div class="table-wrapper"><table');
    processed = processed.replace(/<\/table>/g, "</table></div>");
    return processed;
};
export const RichText = styled(StylableRichText) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=RichText.js.map